module.exports = __webpack_public_path__ + "img/20170704_135648_097.459c0c34.jpg";